import React from "react";
import {
    Card,
    CardContent,
    Typography,
    Box,
    Divider,
} from "@mui/material";
import AsyncString from "../shared/asyncString";
import { Coordinates } from "../listingSearchPage/dialog/mapDialog";

interface OSMResponseProps {
    addressDetails?: Coordinates | null;
}

export const OSMDisplayCard: React.FC<OSMResponseProps> = ({
    addressDetails
}) => {

    if (!addressDetails) {
        return <div />
    }

    return (
        <Card sx={{ maxWidth: 500, margin: "auto", mt: 4, p: 2 }}>
            <CardContent>
                <Typography variant="h5" gutterBottom>
                    <AsyncString stringId={"location-details"} />
                </Typography>
                <Divider sx={{ mb: 2 }} />
                <Box sx={{ mb: 1 }}>
                    <Typography variant="subtitle1">
                        <AsyncString stringId={"latitude"} />:
                    </Typography>
                    <Typography variant="body2">{addressDetails.lat ?? ''}</Typography>
                </Box>
                <Box sx={{ mb: 1 }}>
                    <Typography variant="subtitle1">
                        <AsyncString stringId={"longitude"} />:
                    </Typography>
                    <Typography variant="body2">{addressDetails.lng ?? ''}</Typography>
                </Box>
            </CardContent>
        </Card>
    );
};

